(function ($) {
	// Update the cart item quantity via AJAX
	function updateCart(itemKey, newQty) {
		var data = {
			action: "woocommerce_update_cart_item",
			cart_item_key: itemKey,
			new_qty: newQty,
		};

		// Add class to cart to indicate loading
		$(".widget_shopping_cart_content").addClass("updating-cart");

		$.ajax({
			type: "POST",
			url: woocommerce_params.ajax_url,
			data: data,
			success: function (response) {
				// Trigger a fragment refresh to update cart content
				// $(document.body).trigger('wc_fragment_refresh');
				$fragments = response.fragments;
				if ($fragments) {
					$.each($fragments, function (key, value) {
						$(key).replaceWith(value);
					});
				}

				// Remove the updating class
				$(".widget_shopping_cart_content").removeClass("updating-cart");
			},
			error: function () {
				// Remove the updating class in case of error as well
				$(".widget_shopping_cart_content").removeClass("updating-cart");
			},
		});
	}

	// Add to cart
	function addToCart($this) {
		const data = {
			product_id: $this.data("product-id"),
			quantity: $this.data("quantity") || 1,
			registry_id: $this.data("registry-id") || "",
		};

		$.ajax({
			type: "POST",
			url: wc_add_to_cart_params.wc_ajax_url
				.toString()
				.replace("%%endpoint%%", "add_to_cart"),
			data: data,
			dataType: "json",
			beforeSend: function (xhr) {
				// you can set the button loading state here
				$this.addClass("loading");
			},
			complete: function (res) {
				// you can remove the button loading state here
				$this.removeClass("loading");
			},
			success: function (res) {
				if (res.error) {
					var msg = res.message || "Cannot add this item to cart.";
					showErrorModal(msg);
				} else {
					$(document.body).trigger("added_to_cart", [
						res.fragments,
						res.cart_hash,
					]);
					$this.text("added to cart");
				}
			},
		});
	}

	// Show error alert using the existing mini-cart-modal
	function showErrorModal(message) {
		var confirmModal = $(".mini-cart-modal");
		confirmModal.data("mode", "error");
		confirmModal.find(".mini-cart-modal__body p").text(message);
		confirmModal.find(".mini-cart-modal__btn--no").hide();
		confirmModal.find(".mini-cart-modal__btn--yes").text("OK");
		confirmModal.addClass("active small");
	}

	// Clear cart
	function clearCart(callback) {
		// Add class to cart to indicate loading
		$(".widget_shopping_cart_content").addClass("updating-cart");

		$.ajax({
			type: "POST",
			url: woocommerce_params.ajax_url,
			data: {
				action: "woocommerce_clear_cart",
			},
			success: function (response) {
				// Remove the updating class
				$(".widget_shopping_cart_content").removeClass("updating-cart");

				callback && callback(true);
			},
			error: function () {
				// Remove the updating class in case of error as well
				$(".widget_shopping_cart_content").removeClass("updating-cart");

				callback && callback(false);
			},
		});
	}

	$(document).ready(function () {
		var confirmModal = $(".mini-cart-modal");
		var confirmModalBody = confirmModal.find(".mini-cart-modal__body");
		var okBtn = confirmModal.find(".mini-cart-modal__btn--yes");
		var cancelBtn = confirmModal.find(".mini-cart-modal__btn--no");

		// Yes/OK button — behaviour depends on current modal mode
		okBtn.on("click", function () {
			if (confirmModal.data("mode") === "error") {
				confirmModal.removeData("mode");
				confirmModal.css("opacity", "0");
				confirmModal.removeClass("active");
				setTimeout(function () {
					confirmModal.removeClass("small");
					cancelBtn.show();
					okBtn.text("Yes");
					confirmModal.css("opacity", "");
				}, 400);
			}
			// confirm mode handled by the per-use .on("click") in the add-to-cart flow
		});

		// Update cart item quantity when input changes
		$(document).on("change", ".woocommerce-mini-cart .qty", function () {
			var cart_item_key = $(this)
				.attr("name")
				.match(/\[(.*?)\]/)[1];
			var new_qty = $(this).val();
			updateCart(cart_item_key, new_qty);
		});

		// Handle increment and decrement buttons for quantity inputs
		$(document).on(
			"click",
			".quantity .increment, .quantity .decrement",
			function () {
				var $input = $(this).siblings('input[type="number"]');
				var currentVal = parseInt($input.val(), 10);
				var max = $input.attr("max")
					? parseInt($input.attr("max"), 10)
					: null;
				var min = $input.attr("min")
					? parseInt($input.attr("min"), 10)
					: 0;

				if ($(this).hasClass("increment")) {
					if (max === null || max === -1 || currentVal < max) {
						$input.val(currentVal + 1).trigger("change");
					}
				} else if ($(this).hasClass("decrement")) {
					if (currentVal > min) {
						$input.val(currentVal - 1).trigger("change");
					}
				}
			},
		);

		function openCart() {
			$(".js-mini-cart").addClass("is-active");
			$("body").addClass("mini-cart-opened");
		}

		// Open mini cart only on successful add to cart
		$(document).ajaxComplete(function (event, xhr, settings) {
			if (settings.url.indexOf("wc-ajax=add_to_cart") !== -1) {
				var res = xhr.responseJSON;
				if (!res || !res.error) {
					openCart();
				}
			}
		});

		// Mini Cart toggle
		$(document).on("click", ".js-mini-cart-btn", function (e) {
			e.preventDefault();
			openCart();
		});

		$(document).on("click", ".js-mini-cart-close", function (e) {
			e.preventDefault();
			$(".js-mini-cart").removeClass("is-active");
			$("body").removeClass("mini-cart-opened");
		});

		$(document).on("click", ".js-mini-cart", function (e) {
			if ($(e.target).hasClass("js-mini-cart")) {
				e.preventDefault();
				$(".js-mini-cart").removeClass("is-active");
				$("body").removeClass("mini-cart-opened");
			}
		});

		// Login toggle in mini cart
		$(document).on("click", ".js-mini-cart-login", function (e) {
			e.preventDefault();
			$(".js-mini-cart-close").trigger("click");
			$(".js-login-popup-toggle").trigger("click");
		});

		// Add to cart for loop items
		$(document).on("click", ".js-loop-add-to-cart", function (e) {
			e.preventDefault();
			var $this = $(this);

			if ($this.hasClass("loading")) {
				return;
			}

			var currentRegistryId =
				$(".js-mini-cart-header").data("current-registry") || null;
			var registryId = $this.data("registry-id") || null;

			addToCart($this);
			// if (
			// 	registryId !== null &&
			// 	currentRegistryId !== null &&
			// 	registryId !== currentRegistryId
			// ) {
			// 	confirmModal.addClass("active");
			// 	confirmModalBody.html(
			// 		"Buying gift from a new registry will clear your current cart.<br>Do you want to proceed?",
			// 	);

			// 	okBtn.off("click").on("click", function () {
			// 		confirmModal.removeClass("active");
			// 		// Clear the cart before adding the new item
			// 		clearCart(function (success) {
			// 			if (success) {
			// 				// Proceed to add the item to the cart
			// 				addToCart($this);
			// 			} else {
			// 				alert(
			// 					"Failed to clear the cart. Please try again.",
			// 				);
			// 			}
			// 		});
			// 	});
			// 	cancelBtn.off("click").on("click", function () {
			// 		confirmModal.removeClass("active");
			// 	});
			// } else {
			// 	// No registry conflict, proceed to add the item to the cart
			// 	addToCart($this);
			// }
		});
	});
})(jQuery);
